<template>
	<div class="breadcrumb-container">
		<nav class="breadcrumb">
			<span v-for="(item, index) in breadcrumbList" :key="index" class="breadcrumb-item">
				<!-- 可点击的面包屑项 -->
				<router-link v-if="index < breadcrumbList.length - 1" :to="item.path" class="breadcrumb-link">
					{{ item.title }}
				</router-link>

				<!-- 当前页面（不可点击） -->
				<span v-else class="breadcrumb-current">
					{{ item.title }}
				</span>

				<!-- 分隔符 -->
				<span v-if="index < breadcrumbList.length - 1" class="breadcrumb-separator">
					>
				</span>
			</span>
		</nav>
	</div>
</template>

<script>
	export default {
		name: 'Breadcrumb',
		data() {
			return {
				breadcrumbList: []
			}
		},
		watch: {
			// 监听路由变化，更新面包屑
			$route: {
				handler() {
					this.getBreadcrumb()
				},
				immediate: true
			}
		},
		methods: {
			getBreadcrumb() {
				// 根据当前路由生成面包屑数据
				const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
				const first = matched[0]

				// 确保首页始终在面包屑中
				if (!this.isDashboard(first)) {
					matched.unshift({
						path: '/',
						meta: {
							title: '首页'
						},
						name: 'Home'
					})
				}

				this.breadcrumbList = matched.filter(item => {
					return item.meta && item.meta.title && item.meta.breadcrumb !== false
				}).map(item => {
					return {
						title: item.meta.title,
						path: this.getRoutePath(item),
						name: item.name
					}
				})

				// 检查URL参数，如果有特定参数则更新最后一级面包屑
				this.updateLastBreadcrumbFromQuery()
			},
			/**
			 * 根据URL查询参数更新最后一级面包屑
			 * 支持的参数：name, title, courseName 等
			 */
			updateLastBreadcrumbFromQuery() {
				if (this.breadcrumbList.length === 0) return

				const query = this.$route.query
				let dynamicTitle = ''

				// 按优先级检查不同的查询参数
				if (query.name) {
					dynamicTitle = query.name
				} else if (query.title) {
					dynamicTitle = query.title
				} else if (query.courseName) {
					dynamicTitle = query.courseName
				} else if (query.pageTitle) {
					dynamicTitle = query.pageTitle
				}

				// 如果找到了动态标题参数，则更新最后一级面包屑
				if (dynamicTitle) {
					try {
						// 解码URL编码的中文字符
						const decodedTitle = decodeURIComponent(dynamicTitle)

						// 更新最后一个面包屑项的标题
						const lastIndex = this.breadcrumbList.length - 1
						this.breadcrumbList[lastIndex] = {
							...this.breadcrumbList[lastIndex],
							title: decodedTitle
						}

						console.log('面包屑已更新:', decodedTitle)
					} catch (error) {
						console.error('解码面包屑标题失败:', error)
						// 如果解码失败，直接使用原始字符串
						const lastIndex = this.breadcrumbList.length - 1
						this.breadcrumbList[lastIndex] = {
							...this.breadcrumbList[lastIndex],
							title: dynamicTitle
						}
					}
				}
			},
			isDashboard(route) {
				const name = route && route.name
				if (!name) {
					return false
				}
				return name.trim() === 'Home'
			},

			getRoutePath(route) {
				// 处理嵌套路由的路径
				if (route.path) {
					return route.path
				}

				// 如果没有完整路径，根据matched路由构建
				const {
					matched
				} = this.$route
				const routeIndex = matched.findIndex(item => item.name === route.name)

				if (routeIndex >= 0) {
					return matched[routeIndex].path
				}

				return route.path || '/'
			}
		}
	}
</script>

<style scoped>
	.breadcrumb-container {
		padding: 12px 0px;
		font-size: 14px;
		color: #666;
		border-bottom: 1px solid #e9ecef;
	}

	.breadcrumb {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 40px;
	}

	.breadcrumb-item {
		display: flex;
		align-items: center;
	}

	.breadcrumb-link {
		color: #007bff;
		text-decoration: none;
		transition: color 0.2s ease;
	}

	.breadcrumb-link:hover {
		color: #0056b3;
		/* text-decoration: underline; */
	}

	.breadcrumb-current {
		color: #6c757d;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 8px;
		color: #adb5bd;
		user-select: none;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.breadcrumb-container {
			padding: 8px 0;
			font-size: 13px;
		}

		.breadcrumb-separator {
			margin: 0 6px;
		}
	}
</style>